import React from 'react';
interface RadioOption {
  value: string;
  label: string;
}
interface RadioGroupProps {
  label?: string;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  name: string;
  error?: string;
}
export function RadioGroup({
  label,
  options,
  value,
  onChange,
  name,
  error
}: RadioGroupProps) {
  return <div className="w-full" data-id="element-294">
      {label && <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-295">
          {label}
        </label>}
      <div className="space-y-2" data-id="element-296">
        {options.map(option => <label key={option.value} className="flex items-center cursor-pointer" data-id="element-297">
            <input type="radio" name={name} value={option.value} checked={value === option.value} onChange={e => onChange(e.target.value)} className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-2 focus:ring-blue-500 cursor-pointer" data-id="element-298" />
            <span className="ml-2 text-sm text-gray-700" data-id="element-299">{option.label}</span>
          </label>)}
      </div>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-300">{error}</p>}
    </div>;
}